<template>
  <PageWithLayout>
    <div class="section_comm">
      <div class="section_head">
          <h2 id="kakaoBody" class="tit_section">공지사항</h2>
          <p class="desc_section">T-Fac 서비스와 관련된 새로운 소식을 전해드립니다.</p>
      </div>
      <div class="section_body">
        <div v-if="noticeDataList.length <= 0" class="no_content_g line_type">
          <span class="txt_item">공지사항이 없습니다.</span>
        </div>
        <div v-else class="tbl_comm tbl_list">
          <table>
            <colgroup>
            <col style=""/>
            <col style="width: 200px;"/>
            </colgroup>
            <tbody>
              <tr v-for="(item,index) in noticeDataList" :key="index">
                <td class="align_left" >
                  <router-link :to="{name : 'NoticeView' , params:{id : item.seq}}" ><span class="txt_ellipsis">{{item.title}}</span></router-link>
                </td>
                <td class="align_right"><span class="txt_date">{{item.noticeRegDt | dateFromatDot2}}</span></td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="tbl_foot" v-if="currentPage < totalPage">
          <button :disabled="currentPage == totalPage" @click="morePage" class="btn_more">더보기 ({{currentPage}}/{{totalPage}})<span class="ico_brand ico_more"></span></button>
        </div>
      </div>
    </div>
  </PageWithLayout>
</template>
<script>
import PageWithLayout from '@/components/layout/PageWithLayout';
import Api from '../../api/notice'

export default {
  name: 'NoticeList',
  components: {
    PageWithLayout,
  },
  data(){
    return{
      noticeDataList:[],
      paginationSize : 10, // 한 페이지당 보여질 게시글 갯수
      currentPage : 1,     // 현재 페이지
      totalCount : 0,      // 총 게시글 갯수
      totalPage : 0,       // 페이징처리된 페이지 수
      pagination : {},
    }
  },
  methods : {
    morePage(){
      this.currentPage += 1;
      this.noticeList();
    },
    async noticeList(){
      // page : 페이지 번호
      // size : 페이지 목록 사이즈
      const page = this.currentPage;
      const size = this.paginationSize
      try {
        const response = await Api.noticeList(page-1, size)
        let resultData = [];
        resultData = response.result.map(x => {
          return{
            noticeRegDt : this.$moment(x.noticeRegDt).format('YYYY-MM-DD'),
            seq : x.seq,
            title: x.title
          }
        })
        this.noticeDataList = this.noticeDataList.concat(resultData);
        this.pagination = response.pagination

      } catch(err){
        console.log(err)
      }
      this.totalPage = this.pagination.totalPage;

    }
  },
  created() {
    this.noticeList();
  }
}
</script>
